import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const CollectionLoadingLayout = () => {
    return (
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Box sx={{ flex: '0 0 10%' }}>
                <Skeleton variant="rectangular" height={80} />
            </Box>
            <Box sx={{ flex: '0 0 80%' }}>
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Box>
            <Box sx={{ flex: '0 0 10%' }}>
                <Skeleton variant="rounded" height={40} />
            </Box>
        </Box>
    );
};
